import React from 'react'
import '../css/page-not-found.style.css'
import MegaHeader from '../components/MegaHeader/MegaHeader'
import Footer from '../components/footer/Footer'
import Button from '../components/CtaButton'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import MegaMenu from '../components/MegaMenu/MegaMenu'

const PageNotFound = () => {

    const location = useLocation()

    const allowedCountries = ["us", "ksa", "au", "uae"];
    const currentCountryFromUrl = allowedCountries.find((country) =>
        location.pathname.includes(`/${country}`)
    );

    const country = useSelector((state) => state.country.name);

    const currentCountry = currentCountryFromUrl
        ? currentCountryFromUrl
        : country;

    return (
        <>
            <MegaMenu />
            <div className="page-not-found-box">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="page-not-found-text">
                                <h1 className='not-found-main-heading'>That's strange…</h1>
                                <h2 className="not-found-sub-heading-text">I can't seem to find what you're looking for.</h2>
                                <div className="not-found-image">
                                    <img src="/images/page-not-found-image.svg" alt="Page Not Found" />
                                </div>
                                <h3 className='not-found-sub-heading-text'>No worries! Let's try somewhere else:</h3>
                                <div className="not-found-button">
                                    <Button text='Return to Home' link={`/${currentCountry && currentCountry !== "PK" ? currentCountry : ""}`} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default PageNotFound